import React, { useEffect, useState } from 'react'
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import '../style.scss'
import { useParams } from 'react-router-dom';
import TableGridView from "../../TableGridView";
import { getContactsRequest, deleteContactRequest } from '../../../store/contacts/actions';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import { Tooltip } from '@material-ui/core';

function ContactPersons({ intl: { messages }, setEditContact, disabled }) {
    const dispatch = useDispatch();
    const { contacts } = useSelector((state) => state.contacts);
    const [selectedContact, setSelectedContact] = useState(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const { id } = useParams();

    useEffect(() => {
       if (id) {
            dispatch(getContactsRequest({ patientId: id, sort: 'created_at,desc' }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    
    //table n grid view render
  const headings = [
    messages.patients.form.contact_namear,
    messages.patients.form.contact_nameen,
    messages.patients.form.mobile,
    messages.patients.form.email,
    messages.patients.form.relation,
    messages.patients.form.contact_reason,
    messages.patients.form.actions,
  ];

  const renderTableData = () => {
    return contacts?.data?.map((contact, i) => {
      const { name, phone_number, email, relation, reason_of_contact } =
        contact;
      return [
        <Tooltip title={name.ar} placement="bottom">
          <span className="arabic_name">
            {name.ar.length > 25 ? `${name.ar.substring(0,25)}...` : name.ar}
          </span>
        </Tooltip>,
        <Tooltip title={name.en} placement="bottom">
          <span className="english_name">
            {name.en.length > 25 ? `${name.en.substring(0,25)}...` : name.en}
          </span>
        </Tooltip>,
        phone_number,
        email,
        relation,
        reason_of_contact,
        <div className="table-actions">
          <DeleteForeverIcon onClick={() => {
            if (!disabled) {
              setSelectedContact(contact);
              setDeleteConfirmation(true);
            }
            }} />
          <EditIcon onClick={() => !disabled && setEditContact(contact)} />
        </div>,
      ];
    });
  };
  
    const handlePageChange = (e, page) => {
        return dispatch(
          getContactsRequest({
              page,
              patientId: id,
              sort: 'created_at,desc',
          })
        );
    };

    if (contacts?.data?.length > 0) {
      return (
        <div style={{ width: '100%' }} className='myscrollbar-container'>
            {contacts ? (
              <TableGridView
                title={null}
                Form={null}
                table={{
                  stickyHeader: true,
                  headings: headings,
                  data: renderTableData(),
                  headClass: "bg-white table-head",
                  noData: messages.noData.no_data,
                }}
                pagination={{
                  count: contacts.last_page,
                  page: contacts.current_page,
                  handleChange: handlePageChange,
                }}
              />
            ) : null}
            <ConfirmDialog show={deleteConfirmation} 
                    onCancel={() => setDeleteConfirmation(false)}
                    onConfirm={() => {
                      dispatch(deleteContactRequest(selectedContact.id));
                      setDeleteConfirmation(false);
                    }}
                    icon={null}
                    content={messages.patients.form.deleteContact}
                    cancelBtn={messages.warningMsgs.cancel}
                    confirmBtn={messages.warningMsgs.confirm} />
          </div>
        );
    } else {
      return (
        <div className="no-data-block">
            {messages.appointments.noContacts}
        </div>
      )
    }
}

export default injectIntl(ContactPersons)